import styled from "styled-components";

import { playerPhoto } from "MVVM/Views/TopPlayers/ViewModel";

interface IHeadshotProps {
  className?: string;
  name: string;
  size: number;
  src?: string | null;
  /** Background zoom in %; larger crops tighter onto the face. */
  zoom?: number;
}

// HLTV player photos are square full-body shots with the face in the top
// fifth; zooming the background onto the head keeps faces readable at small
// sizes. The initials underneath show if the image is missing or fails.
export const Headshot = ({
  className,
  name,
  size,
  src,
  zoom = 250,
}: IHeadshotProps) => {
  const url = playerPhoto(src);
  return (
    <Circle aria-hidden className={className} $size={size}>
      <Initials $size={size}>{name.slice(0, 2)}</Initials>
      {url && (
        <Photo
          style={{
            backgroundImage: `url("${url}")`,
            backgroundSize: `${zoom}%`,
          }}
        />
      )}
    </Circle>
  );
};

const Circle = styled.span<{ $size: number }>`
  background: ${({ theme }) => theme.colors.navy100};
  border-radius: 50%;
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.chalkAlpha20};
  clip-path: inset(0 round 50%);
  display: inline-flex;
  flex-shrink: 0;
  height: ${({ $size }) => $size}px;
  position: relative;
  width: ${({ $size }) => $size}px;
`;

const Initials = styled.span<{ $size: number }>`
  align-items: center;
  color: ${({ theme }) => theme.colors.chalk};
  display: flex;
  font-family: Barlow, sans-serif;
  font-size: ${({ $size }) => Math.round($size * 0.32)}px;
  font-style: italic;
  font-weight: 900;
  inset: 0;
  justify-content: center;
  position: absolute;
  text-transform: uppercase;
`;

const Photo = styled.span`
  background-position: 50% 6%;
  background-repeat: no-repeat;
  inset: 0;
  position: absolute;
`;
